/**
 * Reducer responsible for handling the actions performed when mutating routes
 */

import { types } from '../actions/types';

const isRoutesStateSet = () => {
    return {
        selectedRouteGroup: null,
        routeGroups: []
    };
};

const initialState = isRoutesStateSet();

/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default function RoutesGroupReducer(state = initialState, action) {
    let newState;
    switch (action.type) {
        case types.ROUTE_GROUP_POST:
            newState = {
                ...state,
                routeGroups: [
                    ...state.routeGroups, 
                    {
                        id: action.payload.id,
                        name: action.payload.name,
                        routeIds: action.payload.routeIds
                    }
                ]
            };
            return newState;

        case types.ROUTE_GROUP_GET:
            newState = {
                ...state,
                routeGroups: action.payload
            }
            return newState;

        case types.ROUTE_GROUP_DELETE:
            // Remove 
            const isDeletedSelected = () => {
                if(action.payload === state.selectedRouteGroup.id){
                    return null
                }
                return state.selectedRouteGroup
            }

            newState = {
                ...state,
                selectedRouteGroup: isDeletedSelected(),
                routeGroups: state.routeGroups.filter(routeGroup => routeGroup.id !== action.payload)
            }
            return newState;

        case types.ROUTE_GROUP_PUT:
            const updateRoutes = () => {
                let id = action.payload.id;

                return state.routes.map((route) => {
                    if (route.id !== id) {
                        return route
                    }
                    return action.payload
                })
            }

            newState = {
                ...state,
                routes: updateRoutes()
            };


            return newState;
            
        case types.ROUTE_GROUP_SELECT:
            return {
                selectedRouteGroup: action.payload,
                routeGroups: [
                    ...state.routeGroups
                ]
            }
        default:
            return state;
    }
}
